function __match(v,ex){if(ex===null)return v===null;if(ex===undefined)return true;const t=typeof ex;if(t==='string'||t==='number'||t==='boolean')return typeof v===t;if(Array.isArray(ex)){if(!Array.isArray(v))return false;return ex.length?v.every(x=>__match(x,ex[0])):true}if(t==='object'){if(!v||typeof v!=='object'||Array.isArray(v))return false;return Object.keys(ex).every(k=>k in v&&__match(v[k],ex[k]))}return v===ex};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.__ex=ex;t.check=v=>__match(v,ex)}return t};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type};
/* tjs <- by-path.ts */

import { XinObject, XinArray, XinScalar } from './xin-types'

import { makeError } from './make-error'

/* line 6 */
function now36() {
    return new Date(parseInt('1000000000', 36) + Date.now())
        .valueOf()
        .toString(36)
        .slice(1);
}
now36.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "by-path.ts:6"
}

let _seq = 0;

/* line 12 */
function seq() {
    return (parseInt('10000', 36) + ++_seq).toString(36).slice(-5);
}
seq.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "by-path.ts:12"
}

/* line 14 */
export function id() {
    return now36() + seq();
}
id.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "by-path.ts:23"
}

const _delete_ = Symbol('delete');

const _newObject_ = Symbol('new-object');

const _auto_ = Symbol('automatic-index');

const Part = Type('Part', undefined, '')

const PartArray = Type('PartArray', undefined, [null])

/* line 23 */
function pathParts(path) {
    if (path === '') {
        return [];
    }
    if (Array.isArray(path)) {
        return path;
    }
    else {
        const parts = [];
        while (path.length > 0) {
            let index = path.search(/\[[^\]]+\]/);
            if (index === -1) {
                parts.push(path.split('.'));
                break;
            }
            else {
                const part = path.slice(0, index);
                path = path.slice(index);
                if (part !== '') {
                    parts.push(part.split('.'));
                }
                index = path.indexOf(']') + 1;
                parts.push(path.slice(1, index - 1));
                                                                          
                if (path.slice(index, index + 1) === '.') {
                    index += 1;
                }
                path = path.slice(index);
            }
        }
        return parts;
    }
}
pathParts.__tjs = {
  "params": {
    "path": {
      "type": {
        "kind": "union",
        "members": [
          {
            "kind": "string"
          },
          {
            "kind": "array",
            "items": {
              "kind": "null"
            }
          }
        ]
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "array",
      "items": {
        "kind": "null"
      }
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "by-path.ts:23"
}

const idPathMaps = new WeakMap();

const IdPathMap = Type('IdPathMap')

/* line 62 */
function buildIdPathValueMap(array,idPath) {
    if (idPathMaps.get(array) === undefined) {
        idPathMaps.set(array, {});
    }

    const map = {};
    idPathMaps.get(array)[idPath] = map;
    if (idPath === '_auto_') {
        array.forEach((item, idx) => {
            if (item[_auto_] === undefined)
                item[_auto_] = id();
            map[item[_auto_] + ''] = idx;
        });
    }
    else {
        array.forEach((item, idx) => {
            map[getByPath(item, idPath) + ''] = idx;
        });
    }
    return map;
}
buildIdPathValueMap.__tjs = {
  "params": {
    "array": {
      "type": {
        "kind": "array",
        "items": {
          "kind": "null"
        }
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {}
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "by-path.ts:62"
}

/* line 86 */
function getIdPathMap(array,idPath) {
    if (idPathMaps.get(array) === undefined ||
        idPathMaps.get(array)[idPath] === undefined) {
        return buildIdPathValueMap(array, idPath);
    }
    else {
        return idPathMaps.get(array)[idPath];
    }
}
getIdPathMap.__tjs = {
  "params": {
    "array": {
      "type": {
        "kind": "array",
        "items": {
          "kind": "null"
        }
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {}
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "by-path.ts:86"
}

/* line 97 */
function keyToIndex(array,idPath, idValue) {
    idValue = idValue + '';
    let idx = getIdPathMap(array, idPath)[idValue];
    if (idx === undefined ||
        getByPath(array[idx], idPath) + '' !== idValue) {
        idx = buildIdPathValueMap(array, idPath)[idValue];
    }
    return idx;
}
keyToIndex.__tjs = {
  "params": {
    "array": {
      "type": {
        "kind": "array",
        "items": {
          "kind": "null"
        }
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "idValue": {
      "type": {
        "kind": "any"
      },
      "required": true
    }
  },
  "returns": {
    "type": {
      "kind": "number"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "by-path.ts:97"
}

/* line 109 */
/* TODO: TS types degraded — obj: XinObject */
function byKey(obj,key, valueToInsert) {
    if (obj[key] === undefined && valueToInsert !== undefined) {
        obj[key] = valueToInsert;
    }
    return obj[key];
}
byKey.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "key": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "valueToInsert": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "by-path.ts:123"
}

/* line 116 */
/* TODO: TS types degraded — array: any[] | XinObject */
function byIdPath(array,idPath,idValue, valueToInsert) {
    let idx = idPath !== '' ? keyToIndex(array, idPath, idValue) : idValue;
    if (valueToInsert === _delete_) {

        if (idx !== undefined) {
            array.splice(idx, 1);
            idPathMaps.delete(array);
        }
        return Symbol('deleted');
    }
    else if (valueToInsert === _newObject_) {
        if (idPath === '' && array[idx] === undefined) {
            array[idx] = {};
        }
    }
    else if (valueToInsert !== undefined) {
        if (idx !== undefined) {
            array[idx] = valueToInsert;
        }
        else if (idPath !== '' &&
            getByPath(valueToInsert, idPath) + '' === idValue + '') {
            array.push(valueToInsert);
            idx = array.length - 1;
        }
        else {
            throw new Error(`byIdPath insert failed at [${idPath}=${idValue}]`);
        }
    }
    return array[idx];
}
byIdPath.__tjs = {
  "params": {
    "array": {
      "type": {
        "kind": "any"
      },
      "required": true
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "idValue": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "valueToInsert": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "by-path.ts:132"
}

/* line 151 */
function expectArray(obj) {
    if (!Array.isArray(obj)) {
        throw makeError('setByPath failed: expected array, found', obj);
    }
}
expectArray.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "by-path.ts:151"
}

/* line 157 */
function expectObject(obj) {
    if (obj == null || !(obj instanceof Object)) {
        throw makeError('setByPath failed: expected Object, found', obj);
    }
}
expectObject.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "by-path.ts:157"
}

/* line 163 */
/* TODO: TS types degraded — obj: XinObject | XinArray */
function getByPath(obj,path) {
    const parts = pathParts(path);
    let found = obj;
    let i, iMax, j, jMax;
    for (i = 0, iMax = parts.length; found !== undefined && i < iMax; i++) {
        const part = parts[i];
        if (Array.isArray(part)) {
            for (j = 0, jMax = part.length; found !== undefined && j < jMax; j++) {
                const key = part[j];
                found = found[key];
            }
        }
        else {
            if (found.length === 0) {
                found = found[Number(part.slice(1))];
                if (part[0] !== '=') {
                    return undefined;
                }
            }
            else if (part.includes('=')) {
                const [idPath, ...tail] = part.split('=');
                found = byIdPath(found, idPath, tail.join('='));
            }
            else {
                j = parseInt(part, 10);
                found = found[j];
            }
        }
    }
    return found;
}
getByPath.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "path": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "by-path.ts:179"
}

/* line 192 */
/* TODO: TS types degraded — orig: XinObject | XinArray */
function setByPath(orig,path, val) {
    let obj = orig;
    if (path === '')
        throw new Error('setByPath cannot be used to set the root object');
    const parts = pathParts(path);
    while (obj != null && parts.length > 0) {
        const part = parts.shift();
        if (typeof part === 'string') {
            const equalsOffset = part.indexOf('=');
            if (equalsOffset > -1) {
                if (equalsOffset === 0) {
                    expectObject(obj);
                }
                else {
                    expectArray(obj);
                }
                const idPath = part.slice(0, equalsOffset);
                const idValue = part.slice(equalsOffset + 1);
                obj = byIdPath(obj, idPath, idValue, parts.length > 0 ? _newObject_ : val);
                if (parts.length === 0) {
                    return true;
                }
            }
            else {
                expectArray(obj);
                const idx = parseInt(part, 10);
                if (parts.length > 0) {
                    obj = obj[idx];
                }
                else {
                    if (val !== _delete_) {
                        if (obj[idx] === val) {
                            return false;
                        }
                        obj[idx] = val;
                    }
                    else {
                        obj.splice(idx, 1);
                    }
                    return true;
                }
            }
        }
        else if (Array.isArray(part) && part.length > 0) {
            expectObject(obj);
            while (part.length > 0) {
                const key = part.shift();
                if (part.length > 0 || parts.length > 0) {
                                                                                         
                    obj = byKey(obj, key, part.length > 0 ? {} : []);
                }
                else {
                    if (val !== _delete_) {
                        if (obj[key] === val) {
                            return false;
                        }
                        obj[key] = val;
                    }
                    else {
                        if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                            return false;
                        }
                        delete obj[key];
                    }
                    return true;
                }
            }
        }
        else {
            throw new Error(`setByPath failed, bad path ${path}`);
        }
    }
    throw new Error(`setByPath(${orig}, ${path}, ${val}) failed`);
}
setByPath.__tjs = {
  "params": {
    "orig": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "path": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "val": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "returns": {
    "type": {
      "kind": "boolean"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "by-path.ts:213"
}

/* line 270 */
/* TODO: TS types degraded — orig: XinObject */
function deleteByPath(orig,path) {
    if (getByPath(orig, path) !== null) {
        setByPath(orig, path, _delete_);
    }
}
deleteByPath.__tjs = {
  "params": {
    "orig": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "path": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "unsafe": true,
  "source": "by-path.ts:290"
}

export { getByPath, setByPath, deleteByPath, pathParts };